import { render, staticRenderFns } from "./PersonDialogCommentTabComponent.vue?vue&type=template&id=6b5acca0&scoped=true"
import script from "./PersonDialogCommentTabComponent.js?vue&type=script&lang=js&external"
export * from "./PersonDialogCommentTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./PersonDialogCommentTabComponent.vue?vue&type=style&index=0&id=6b5acca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5acca0",
  null
  
)

export default component.exports